export class UpcomingPastBookingContext {

    public routeTo: string[] = []
    public nextTo: string = ""
    public bookingId!: string
    constructor() { }
}